/* Kuk ürün sayfası (sop/urun.json). Varyant ve saksı seçimi, fiyat ve stok güncellemesi, sepete ekleme, galeri,
   tam ekran görüntüleyici, 'Gelince haber ver', yapışkan sepet barı, açıklama ve benzer bitkiler.
   Ortak yardımcılar (fiyat biçimi, alt sayfa, kilit) assets/kuk-ortak.js'te.
   Fiyat ve hal Liquid'den gelir (snippets/kuk-stok-hali.liquid tek kaynak); JS yalnız günceller, animasyon yok.
   Olaylar: 'kuk:olay' (ölçüm: add_to_cart, gelince_haber_ver), 'kuk:sepete-eklendi' (sepet çekmecesi dinler;
   dinleyen yoksa /cart açılır), 'kuk:urun-durumu' (yapışkan bar). */
(() => {
  if (window.kukUrunYuklu) return;
  window.kukUrunYuklu = true;

  // Ortak yardımcılar: assets/kuk-ortak.js (layout/theme.liquid)
  const { kaydirma, para, doldur, kacis, olay, kilit, surukleKapat, altSayfa } = window.kukOrtak;

  class KukUrun extends HTMLElement {
    connectedCallback() {
      this.varyantlar = JSON.parse(this.querySelector('[data-kuk-varyantlar]').textContent);
      this.metin = JSON.parse(this.querySelector('[data-kuk-metinler]').textContent);
      this.sezonDisi = this.dataset.sezonDisi === 'true';
      this.form = this.querySelector('[data-kuk-form]');
      this.girdi = this.querySelector('[data-kuk-varyant-girdi]');
      this.satinAl = this.querySelector('[data-kuk-satin-al]');
      this.buton = this.querySelector('[data-kuk-buton]');
      this.butonMetni = this.querySelector('[data-kuk-buton-metni]');
      this.adetSayi = this.querySelector('[data-kuk-adet-sayi]');
      this.adetGirdi = this.querySelector('[data-kuk-adet-girdi]');
      this.hata = this.querySelector('[data-kuk-hata]');
      this.sinirSatiri = this.querySelector('[data-kuk-sinir]');
      this.galeri = this.querySelector('kuk-galeri');
      this.varyant = this.varyantlar.find((v) => v.id === Number(this.girdi.value)) || this.varyantlar[0];
      this.saksi = { id: null, fiyat: 0, ad: '' };
      this.adet = 1;

      this.form.addEventListener('change', (e) => {
        if (e.target.matches('.kuk-secici__girdi')) this.secenekDegisti(e.target);
        else if (e.target.matches('.kuk-saksi__girdi')) this.saksiDegisti(e.target);
      });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.ekle('urun_sayfasi'); });
      this.buton.addEventListener('click', (e) => {
        if (this.varyant.hal === 'tukendi') { e.preventDefault(); this.haberVerAc(); }
      });
      this.querySelectorAll('[data-adet-degis]').forEach((b) =>
        b.addEventListener('click', () => this.adetAyarla(this.adet + Number(b.dataset.adetDegis)))
      );
      this.querySelectorAll('[data-renk]').forEach((b) => b.addEventListener('click', () => this.renkSec(b)));
      this.querySelector('[data-kuk-boy-rehberi]')?.addEventListener('click', () => zoom.ac('rehber', this.galeri));
      window.addEventListener('pageshow', () => this.yuklemeBitti());

      window.kukUrun = this;
      this.uygunlukIsaretle();
      this.ciz({ ilk: true });
    }

    seciliSecenekler() {
      return [...this.querySelectorAll('.kuk-secici')].map((g) => g.querySelector('.kuk-secici__girdi:checked')?.value);
    }

    // Seçilen değerle eşleşen varyant yoksa o değeri taşıyan ilk (tercihen stoktaki) varyanta geçilir
    secenekDegisti(girdi) {
      const grup = Number(girdi.closest('.kuk-secici').dataset.grup);
      const secim = this.seciliSecenekler();
      let v = this.varyantlar.find((x) => x.secenekler.every((s, i) => s === secim[i]));
      if (!v) {
        const adaylar = this.varyantlar.filter((x) => x.secenekler[grup] === girdi.value);
        v = adaylar.find((x) => x.hal !== 'tukendi') || adaylar[0];
        if (!v) return;
        this.querySelectorAll('.kuk-secici').forEach((g, i) => {
          const r = [...g.querySelectorAll('.kuk-secici__girdi')].find((x) => x.value === v.secenekler[i]);
          if (r) r.checked = true;
        });
      }
      this.varyant = v;
      this.girdi.value = v.id;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState(window.history.state, '', url.toString());
      this.uygunlukIsaretle();
      this.ciz();
      if (v.medya && this.galeri) this.galeri.medyayaGit(v.medya);
    }

    // Tükenen seçenek: diğer seçili değerlerle eşleşen varyant tükendiyse buton soluk ve çapraz çizgili
    uygunlukIsaretle() {
      const secim = this.seciliSecenekler();
      this.querySelectorAll('.kuk-secici').forEach((g, i) => {
        g.querySelector('[data-secili-deger]').textContent = secim[i] ?? '';
        g.querySelectorAll('.kuk-secici__girdi').forEach((r) => {
          const uygun = this.varyantlar.some((x) => x.hal !== 'tukendi' && x.secenekler[i] === r.value
            && x.secenekler.every((s, j) => j === i || s === secim[j]));
          const etiket = r.nextElementSibling;
          etiket.classList.toggle('is-tukendi', !uygun);
          let gizli = etiket.querySelector('.visually-hidden');
          if (!uygun && !gizli) {
            gizli = document.createElement('span');
            gizli.className = 'visually-hidden';
            gizli.textContent = `, ${this.metin.tukendi}`;
            etiket.append(gizli);
          } else if (uygun && gizli) gizli.remove();
        });
      });
    }

    saksiDegisti(girdi) {
      this.saksi = girdi.value ? { id: Number(girdi.value), fiyat: Number(girdi.dataset.fiyat), ad: girdi.dataset.ad } : { id: null, fiyat: 0, ad: '' };
      const kutu = girdi.closest('[data-kuk-saksi]');
      kutu.querySelector('[data-secili-deger]').textContent = girdi.value ? girdi.dataset.ad : this.metin.uretici;
      kutu.querySelectorAll('[data-renkler-urun]').forEach((r) => { r.hidden = r.dataset.renklerUrun !== girdi.dataset.urun; });
      this.ciz();
    }

    renkSec(dugme) {
      const grup = dugme.closest('[data-renkler-urun]');
      const girdi = this.querySelector(`.kuk-saksi__girdi[data-urun="${grup.dataset.renklerUrun}"]`);
      grup.querySelectorAll('[data-renk]').forEach((b) => {
        b.classList.toggle('is-secili', b === dugme);
        b.setAttribute('aria-pressed', String(b === dugme));
      });
      girdi.value = dugme.dataset.renk;
      girdi.dataset.fiyat = dugme.dataset.fiyat;
      const fiyat = girdi.nextElementSibling.querySelector('.kuk-saksi__fiyat');
      if (fiyat) fiyat.textContent = `+${para(dugme.dataset.fiyat)}`;
      girdi.checked = true;
      this.saksi = { id: Number(dugme.dataset.renk), fiyat: Number(dugme.dataset.fiyat), ad: dugme.dataset.ad };
      girdi.closest('[data-kuk-saksi]').querySelector('[data-secili-deger]').textContent = dugme.dataset.ad;
      this.ciz();
    }

    adetAyarla(n) {
      const sinir = this.varyant.sinir;
      const ust = sinir === null ? 99 : Math.max(1, sinir);
      this.adet = Math.min(Math.max(1, n), ust);
      this.adetSayi.textContent = this.adet;
      this.adetGirdi.value = this.adet;
      this.querySelector('[data-adet-degis="-1"]').disabled = this.adet <= 1;
      this.querySelector('[data-adet-degis="1"]').disabled = this.adet >= ust;
      const sinirda = sinir !== null && this.adet >= sinir && this.varyant.hal !== 'tukendi';
      this.sinirSatiri.hidden = !sinirda;
      if (sinirda) this.sinirSatiri.textContent = doldur(this.metin.stokSiniri, { adet: sinir });
    }

    rozetMetni() {
      const v = this.varyant;
      if (v.hal === 'tukendi') return this.sezonDisi ? this.metin.sezonDisi : this.metin.tukendi;
      if (v.hal === 'on_siparis') return this.metin.onSiparis;
      if (v.eski > v.fiyat) return doldur(this.metin.indirim, { oran: Math.floor(((v.eski - v.fiyat) * 100) / v.eski) });
      return '';
    }

    stokMetni() {
      const v = this.varyant;
      if (v.hal === 'stokta') return this.metin.stokta;
      if (v.hal === 'on_siparis') return doldur(this.metin.barOnSiparis, { tarih: v.tarih });
      return this.sezonDisi ? this.metin.sezonDisi : this.metin.tukendi;
    }

    butonMetniBul() {
      const hal = this.varyant.hal;
      if (hal === 'stokta') return this.metin.sepeteEkle;
      if (hal === 'on_siparis') return this.metin.onSiparisVer;
      return this.metin.gelinceHaberVer;
    }

    ciz({ ilk = false } = {}) {
      const v = this.varyant;
      const m = this.metin;
      const s = this.saksi.fiyat;
      const tukendi = v.hal === 'tukendi';

      // Fiyat (sop/urun.json 5): saksı seçiliyse büyük rakam toplam, altında döküm
      this.querySelector('[data-kuk-tutar]').textContent = para(v.fiyat + s);
      const eski = this.querySelector('[data-kuk-eski]');
      const tasarruf = this.querySelector('[data-kuk-tasarruf]');
      const indirimli = v.eski > v.fiyat;
      eski.hidden = !indirimli;
      tasarruf.hidden = !indirimli;
      if (indirimli) {
        eski.innerHTML = `<span class="visually-hidden">${kacis(m.eskiFiyat)} </span>${para(v.eski + s)}`;
        tasarruf.textContent = doldur(m.tasarruf, { tutar: para(v.eski - v.fiyat) });
      }
      const dokum = this.querySelector('[data-kuk-dokum]');
      dokum.hidden = s <= 0;
      if (s > 0) dokum.textContent = doldur(m.dokum, { bitki: para(v.fiyat), saksi: para(s) });

      if (!ilk) {
        // Stok satırı (sop/urun.json 7), Liquid kuk-stok-satiri ile aynı işaretleme
        let rozet = m.stokta;
        let tip = 'stokta';
        let not = '';
        if (v.hal === 'on_siparis') { rozet = m.onSiparis; tip = 'standart'; not = doldur(m.tahminiGonderim, { tarih: v.tarih }); }
        if (tukendi) { rozet = this.sezonDisi ? m.sezonDisi : m.tukendi; tip = 'standart'; not = m.haberVerelim; }
        this.querySelector('[data-kuk-stok]').innerHTML = `<span class="kuk-rozet kuk-rozet--${tip}">${kacis(rozet)}</span>${not ? `<span class="kuk-stok__not">${kacis(not)}</span>` : ''}`;

        // Galeri rozeti
        const rozetYeri = this.querySelector('[data-kuk-galeri-rozet]');
        const galeriRozet = this.rozetMetni();
        if (rozetYeri) rozetYeri.innerHTML = galeriRozet ? `<span class="kuk-rozet kuk-rozet--standart">${kacis(galeriRozet)}</span>` : '';

        // Boy/form satırı: varyantın değeri yoksa ürün değeri kalır
        const boyForm = this.querySelector('[data-kuk-boy-form]');
        boyForm.textContent = v.boyForm || '';
        boyForm.hidden = !v.boyForm;

        // Buton (sop/urun.json 12): tükendi halinde ikincil, tam genişlik, adet gizli
        this.satinAl.classList.toggle('is-tukendi', tukendi);
        this.buton.type = tukendi ? 'button' : 'submit';
        this.buton.classList.toggle('kuk-buton--ikincil', tukendi);
        this.buton.classList.toggle('kuk-buton--birincil', !tukendi);
        this.butonMetni.textContent = this.butonMetniBul();
        this.querySelector('[data-kuk-benzer-baglanti]').hidden = !tukendi;
        this.hata.hidden = true;

        // 1. güven satırı: hal başına cümle
        this.querySelectorAll('[data-guven-hal]').forEach((el) => { el.hidden = el.dataset.guvenHal !== v.hal; });
        this.querySelectorAll('[data-kuk-tarih]').forEach((el) => { el.textContent = v.tarih; });

        // Gelince haber ver formu seçili varyantı taşır
        const haberVer = document.querySelector('[data-kuk-haber-ver]');
        if (haberVer) {
          const ad = this.querySelector('.kuk-urun__baslik').textContent.trim();
          const etiket = this.varyantlar.length > 1 ? `${ad}, ${v.ad}` : ad;
          haberVer.querySelector('[data-haber-ver-urun]').textContent = etiket;
          haberVer.querySelector('[data-haber-ver-urun-alani]').value = etiket;
          haberVer.querySelector('[data-haber-ver-varyant]').value = v.id;
        }
      }
      this.adetAyarla(this.adet);

      document.dispatchEvent(new CustomEvent('kuk:urun-durumu', {
        detail: { fiyat: para(v.fiyat + s), stok: this.stokMetni(), hal: v.hal, butonMetni: this.butonMetniBul() },
      }));
    }

    haberVerAc() {
      altSayfa.ac(document.querySelector('[data-kuk-haber-ver]'));
    }

    yukleniyor(acik) {
      this.mesgul = acik;
      document.querySelectorAll('[data-kuk-buton], [data-kuk-bar-buton]').forEach((b) => {
        b.classList.toggle('is-yukleniyor', acik);
        const metin = b.querySelector('[data-kuk-buton-metni], [data-kuk-bar-buton-metni]');
        if (metin) metin.textContent = acik ? this.metin.ekleniyor : this.butonMetniBul();
      });
    }

    yuklemeBitti() {
      if (this.mesgul) this.yukleniyor(false);
    }

    // Sepete ekleme: bitki ve seçili saksı tek istekte iki satır (cart/add.js items); saksı satırında gizli _bitki
    // özelliği bitki varyantının kimliğidir (sepette saksı satırı bitkisinin altına dizilir, snippets/kuk-sepet-satirlar.liquid)
    async ekle(kaynak) {
      if (this.varyant.hal === 'tukendi') { this.haberVerAc(); return; }
      if (this.mesgul) return;
      this.yukleniyor(true);
      this.hata.hidden = true;
      const items = [{ id: this.varyant.id, quantity: this.adet }];
      if (this.saksi.id) items.push({ id: this.saksi.id, quantity: this.adet, properties: { _bitki: String(this.varyant.id) } });
      // Sepet çekmecesi varsa yanıtla birlikte çizilir (sections/kuk-sepet-cekmecesi.liquid)
      const bolumler = ['cart-icon-bubble'];
      const cekmece = document.querySelector('kuk-sepet[data-baglam="cekmece"]');
      if (cekmece) bolumler.push(cekmece.dataset.bolum);
      const zamanAsimi = new AbortController();
      const sayac = setTimeout(() => zamanAsimi.abort(), 15000);
      try {
        const yanit = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: bolumler.join(','), sections_url: window.location.pathname }),
          signal: zamanAsimi.signal,
        });
        const veri = await yanit.json();
        if (!yanit.ok) throw Object.assign(new Error('sepet'), { durum: yanit.status, veri });
        const html = veri.sections && veri.sections['cart-icon-bubble'];
        const hedef = document.getElementById('cart-icon-bubble');
        if (html && hedef) {
          const ic = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (ic) hedef.innerHTML = ic.innerHTML;
        }
        olay('add_to_cart', { urun_id: Number(this.dataset.urunId), varyant: this.varyant.id, saksi: this.saksi.id, adet: this.adet, kaynak });
        const bildir = new CustomEvent('kuk:sepete-eklendi', { detail: veri, cancelable: true });
        document.dispatchEvent(bildir);
        if (!bildir.defaultPrevented) { window.location.href = window.routes.cart_url; return; }
        this.yukleniyor(false);
      } catch (hata) {
        this.yukleniyor(false);
        const sinir = this.varyant.sinir;
        this.hata.textContent = hata.durum === 422 && sinir !== null
          ? doldur(this.metin.hataStok, { adet: sinir })
          : this.metin.hataBaglanti;
        this.hata.hidden = false;
      } finally {
        clearTimeout(sayac);
      }
    }
  }

  /* Galeri (sop/urun.json 2): kaydırma ile küçük resim eşlemesi, video, görüntüleyiciye geçiş */
  class KukGaleri extends HTMLElement {
    connectedCallback() {
      this.kareler = this.querySelector('[data-kareler]');
      this.serit = this.querySelector('.kuk-galeri__serit');
      this.kucukler = [...this.querySelectorAll('[data-git]')];
      this.sira = 0;
      this.kucukler.forEach((b) => b.addEventListener('click', () => this.git(Number(b.dataset.git))));
      this.querySelectorAll('[data-buyut]').forEach((b) => b.addEventListener('click', () => zoom.ac(Number(b.dataset.buyut), this)));
      this.querySelectorAll('[data-oynat]').forEach((b) => b.addEventListener('click', () => this.oynat(b)));
      let bekliyor = false;
      this.kareler.addEventListener('scroll', () => {
        if (bekliyor) return;
        bekliyor = true;
        requestAnimationFrame(() => {
          bekliyor = false;
          const sira = Math.round(this.kareler.scrollLeft / Math.max(1, this.kareler.clientWidth));
          if (sira !== this.sira) this.isaretle(sira);
        });
      }, { passive: true });
      const ilk = window.kukUrun && window.kukUrun.varyant && window.kukUrun.varyant.medya;
      if (ilk) requestAnimationFrame(() => this.medyayaGit(ilk, true));
    }

    git(sira, anlik = false) {
      this.kareler.scrollTo({ left: sira * this.kareler.clientWidth, behavior: anlik ? 'auto' : kaydirma() });
      this.isaretle(sira);
    }

    medyayaGit(id, anlik = false) {
      const kare = this.querySelector(`[data-medya-id="${id}"]`);
      if (kare) this.git(Number(kare.dataset.sira), anlik);
    }

    isaretle(sira) {
      this.sira = sira;
      this.kucukler.forEach((b, i) => {
        if (i === sira) {
          b.setAttribute('aria-current', 'true');
          if (this.serit) {
            const sol = b.offsetLeft - 16;
            const sag = b.offsetLeft + b.offsetWidth + 16 - this.serit.clientWidth;
            if (this.serit.scrollLeft > sol) this.serit.scrollLeft = sol;
            else if (this.serit.scrollLeft < sag) this.serit.scrollLeft = sag;
          }
        } else b.removeAttribute('aria-current');
      });
      // Kare değişince video durur
      this.querySelectorAll('.kuk-galeri__kare video').forEach((v) => {
        if (Number(v.closest('.kuk-galeri__kare').dataset.sira) !== sira) v.pause();
      });
    }

    oynat(dugme) {
      const kutu = dugme.closest('[data-video]');
      const sablon = kutu.querySelector('template');
      kutu.replaceChildren(sablon.content.cloneNode(true));
      const video = kutu.querySelector('video');
      if (video) { video.muted = true; video.play().catch(() => {}); }
    }
  }

  /* Tam ekran görüntüleyici (sop/urun.json 3) */
  const zoom = {
    hazirla() {
      if (this.dialog) return true;
      this.dialog = document.querySelector('[data-kuk-zoom]');
      if (!this.dialog) return false;
      this.kareler = this.dialog.querySelector('[data-zoom-kareler]');
      this.sayac = this.dialog.querySelector('[data-zoom-sayac]');
      this.toplam = this.kareler.children.length;
      this.dialog.querySelector('[data-zoom-kapat]').addEventListener('click', () => this.dialog.close());
      this.dialog.querySelectorAll('[data-zoom-git]').forEach((b) => b.addEventListener('click', () => this.git(this.sira + Number(b.dataset.zoomGit))));
      this.dialog.addEventListener('close', () => {
        kilit.kapat();
        this.dialog.querySelectorAll('.is-yakin').forEach((c) => c.classList.remove('is-yakin'));
        if (this.galeri && this.sira < this.galeri.kucukler.length) this.galeri.git(this.sira, true);
      });
      this.kareler.addEventListener('scroll', () => {
        const sira = Math.round(this.kareler.scrollLeft / Math.max(1, this.kareler.clientWidth));
        if (sira !== this.sira) this.isaretle(sira);
      }, { passive: true });
      // Çift dokunuş: 2 kat, dokunulan noktaya
      this.dialog.querySelectorAll('[data-zoom-cerceve]').forEach((c) => {
        let son = 0;
        c.addEventListener('click', (e) => {
          const simdi = Date.now();
          if (simdi - son < 300) {
            const r = c.getBoundingClientRect();
            const oranX = (e.clientX - r.left) / r.width;
            const oranY = (e.clientY - r.top) / r.height;
            const yakin = c.classList.toggle('is-yakin');
            if (yakin) {
              c.scrollLeft = oranX * c.scrollWidth - r.width / 2;
              c.scrollTop = oranY * c.scrollHeight - r.height / 2;
            }
            son = 0;
          } else son = simdi;
        });
      });
      surukleKapat(this.dialog, () => this.dialog.close(), () => !this.dialog.querySelector('.is-yakin'));
      return true;
    },
    ac(sira, galeri) {
      if (!this.hazirla()) return;
      this.galeri = galeri;
      const hedef = sira === 'rehber'
        ? Number(this.dialog.querySelector('[data-zoom-boy-rehberi]')?.dataset.sira ?? 0)
        : sira;
      this.dialog.showModal();
      kilit.ac();
      this.kareler.scrollLeft = hedef * this.kareler.clientWidth;
      this.isaretle(hedef);
    },
    git(sira) {
      const hedef = Math.min(Math.max(0, sira), this.toplam - 1);
      this.kareler.scrollTo({ left: hedef * this.kareler.clientWidth, behavior: kaydirma() });
      this.isaretle(hedef);
    },
    isaretle(sira) {
      this.sira = sira;
      this.sayac.textContent = `${sira + 1} / ${this.toplam}`;
    },
  };

  /* 'Gelince haber ver' formu (sop/urun.json 29). Arka uç geçici: Shopify iletişim formu */
  const haberVerHazirla = () => {
    const dialog = document.querySelector('[data-kuk-haber-ver]');
    if (!dialog) return;
    const form = dialog.querySelector('form');
    const hataSatiri = dialog.querySelector('[data-haber-ver-hata]');
    const gonder = dialog.querySelector('[data-haber-ver-gonder]');
    const eposta = form.querySelector('input[type="email"]');
    const telefon = form.querySelector('input[type="tel"]');
    const onay = form.querySelector('[data-haber-ver-onay]');
    const metinler = {
      alan: dialog.dataset.hataAlan,
      onay: dialog.dataset.hataOnay,
      baglanti: dialog.dataset.hataBaglanti,
    };
    form.noValidate = true;
    const hataGoster = (metin) => { hataSatiri.textContent = metin; hataSatiri.hidden = !metin; };
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const ePosta = eposta.value.trim();
      const tel = telefon.value.replace(/\D/g, '');
      const epostaGecerli = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(ePosta);
      const telGecerli = tel.length >= 10 && tel.length <= 11;
      eposta.classList.toggle('is-hatali', !!ePosta && !epostaGecerli);
      telefon.classList.toggle('is-hatali', !!tel && !telGecerli);
      if ((!ePosta && !tel) || (ePosta && !epostaGecerli) || (tel && !telGecerli)) {
        if (!ePosta && !tel) eposta.classList.add('is-hatali');
        hataGoster(metinler.alan);
        return;
      }
      onay.closest('.kuk-onay').classList.toggle('is-hatali', !onay.checked);
      if (!onay.checked) { hataGoster(metinler.onay); return; }
      hataGoster('');
      gonder.classList.add('is-yukleniyor');
      try {
        const yanit = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
        if (yanit.url.includes('/challenge')) { form.submit(); return; }
        if (!yanit.ok || !yanit.url.includes('contact_posted=true')) throw new Error('form');
        dialog.querySelector('[data-haber-ver-form-alani]').hidden = true;
        dialog.querySelector('[data-haber-ver-basari]').hidden = false;
        const urun = window.kukUrun;
        olay('gelince_haber_ver', { urun_id: urun ? Number(urun.dataset.urunId) : null, varyant: urun ? urun.varyant.id : null, kanal: ePosta ? 'eposta' : 'sms' });
      } catch (hata) {
        hataGoster(metinler.baglanti);
      } finally {
        gonder.classList.remove('is-yukleniyor');
      }
    });
  };

  /* Yapışkan sepet barı (sop/urun.json 27): ana buton görülüp yukarı kaybolunca girer, geri gelince çıkar */
  class KukBar extends HTMLElement {
    connectedCallback() {
      this.kutu = this.querySelector('.kuk-bar');
      this.fiyat = this.querySelector('[data-kuk-bar-fiyat]');
      this.stok = this.querySelector('[data-kuk-bar-stok]');
      this.buton = this.querySelector('[data-kuk-bar-buton]');
      this.butonMetni = this.querySelector('[data-kuk-bar-buton-metni]');
      document.addEventListener('kuk:urun-durumu', (e) => this.guncelle(e.detail));
      this.buton.addEventListener('click', () => {
        const urun = window.kukUrun;
        if (!urun) return;
        if (urun.varyant.hal === 'tukendi') urun.haberVerAc();
        else urun.ekle('yapiskan_bar');
      });
      this.querySelector('[data-kuk-bar-sol]').addEventListener('click', () => {
        document.querySelector('[data-kuk-fiyat]')?.scrollIntoView({ behavior: kaydirma(), block: 'center' });
      });
      // Konum her kaydırmada okunur: çapa bağlantısıyla butonun üstünden tek hamlede atlanınca da bar gelir
      const anaButon = document.querySelector('[data-kuk-buton]');
      if (anaButon) {
        let bekliyor = false;
        const bak = () => {
          bekliyor = false;
          this.kutu.classList.toggle('is-gorunur', anaButon.getBoundingClientRect().bottom < 0);
        };
        const iste = () => { if (!bekliyor) { bekliyor = true; requestAnimationFrame(bak); } };
        window.addEventListener('scroll', iste, { passive: true });
        window.addEventListener('resize', iste);
        bak();
      }
      // Klavye açıkken bar gizli
      document.addEventListener('focusin', (e) => {
        if (e.target.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]), textarea, select')) {
          document.documentElement.classList.add('kuk-klavye-acik');
        }
      });
      document.addEventListener('focusout', () => document.documentElement.classList.remove('kuk-klavye-acik'));
      if (window.kukUrun) window.kukUrun.ciz({ ilk: true });
    }

    guncelle({ fiyat, stok, hal, butonMetni }) {
      this.fiyat.textContent = fiyat;
      this.stok.textContent = stok;
      this.buton.classList.toggle('kuk-buton--ikincil', hal === 'tukendi');
      this.buton.classList.toggle('kuk-buton--birincil', hal !== 'tukendi');
      if (!this.buton.classList.contains('is-yukleniyor')) this.butonMetni.textContent = butonMetni;
    }
  }

  /* Açıklama (sop/urun.json 17): 3 paragrafı aşarsa kalanı 'Devamını oku' ile yerinde açılır */
  class KukAciklama extends HTMLElement {
    connectedCallback() {
      const govde = this.querySelector('[data-aciklama-govde]');
      const dugme = this.querySelector('[data-aciklama-devam]');
      if (!govde || !dugme) return;
      const bloklar = [...govde.children].filter((el) => el.textContent.trim() !== '' || el.querySelector('img'));
      if (bloklar.length <= 3) return;
      const gizlenecek = bloklar.slice(3);
      const ilkGizli = gizlenecek[0];
      [...govde.children].forEach((el) => {
        if (el.compareDocumentPosition(ilkGizli) & Node.DOCUMENT_POSITION_PRECEDING || el === ilkGizli) el.hidden = true;
      });
      dugme.hidden = false;
      dugme.addEventListener('click', () => {
        [...govde.children].forEach((el) => { el.hidden = false; });
        dugme.remove();
      });
    }
  }

  /* Benzer bitkiler (sop/urun.json 24): Shopify ilgili ürün önerisi, önce aynı ışık değerindekiler.
     Tükenmiş üründe bölüm güven satırlarının altına taşınır (sop/urun.json 28). */
  class KukBenzer extends HTMLElement {
    connectedCallback() {
      // Taşıma öğeyi yeniden bağlar ve bu fonksiyon tekrar çalışır; ikinci kez hiçbir şey yapılmaz
      if (this.hazir) return;
      this.hazir = true;
      const tumuTukendi = document.querySelector('kuk-urun')?.dataset.tumuTukendi === 'true';
      if (tumuTukendi) this.tasi();
      if (!('IntersectionObserver' in window)) { this.yukle(); return; }
      // Bölüm boşken gizli olduğu için gözlenen öğe bölüm kabıdır (yüksekliği 0 olsa da konumu vardır)
      const hedef = this.closest('.shopify-section') || this;
      const izle = new IntersectionObserver(([g]) => {
        if (!g.isIntersecting) return;
        izle.disconnect();
        this.yukle();
      }, { rootMargin: '0px 0px 600px 0px' });
      izle.observe(hedef);
    }

    tasi() {
      const bolum = this.closest('.shopify-section');
      const yer = document.querySelector('[data-kuk-benzer-yeri]');
      if (bolum && yer && !yer.contains(bolum)) yer.append(bolum);
    }

    // Öneri motoru en az 2 stoktaki ürün dönerse Liquid'in bastığı yedek liste (aynı ürün tipi) yerine geçer
    async yukle() {
      const kutu = this.closest('[data-benzer-bolum]');
      try {
        const yanit = await fetch(this.dataset.url);
        if (!yanit.ok) return;
        const belge = new DOMParser().parseFromString(await yanit.text(), 'text/html');
        const liste = belge.querySelector('kuk-benzer [data-kartlar]');
        const kartlar = liste ? [...liste.querySelectorAll('[data-kart]')] : [];
        if (kartlar.length < 2) return;
        const isik = this.dataset.isik;
        if (isik) kartlar.sort((a, b) => (b.dataset.isik === isik) - (a.dataset.isik === isik));
        kartlar.forEach((k) => liste.append(k));
        this.replaceChildren(document.importNode(liste, true));
        if (kutu) kutu.hidden = false;
      } catch (hata) {
        // Öneri gelmezse yedek liste kalır
      }
    }
  }

  if (!customElements.get('kuk-urun')) customElements.define('kuk-urun', KukUrun);
  if (!customElements.get('kuk-galeri')) customElements.define('kuk-galeri', KukGaleri);
  if (!customElements.get('kuk-bar')) customElements.define('kuk-bar', KukBar);
  if (!customElements.get('kuk-aciklama')) customElements.define('kuk-aciklama', KukAciklama);
  if (!customElements.get('kuk-benzer')) customElements.define('kuk-benzer', KukBenzer);
  haberVerHazirla();
})();
